import React from 'react';
import { createRoot } from 'react-dom/client';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import Reducers from './reducers';
import App from './App';
import './i18n';
import { reportWebVitals } from './helpers/webVitals';

const store = createStore(Reducers);

const root = createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </HelmetProvider>
);

// Core Web Vitals reporting
reportWebVitals(console.log);
